import React from "react";
import { Image, ScrollView, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { useNavigate } from "react-router-dom";

const footerLinks = [
  { label: "Terms & Conditions", tab: "T&C" },
  { label: "Shipping Policy", tab: "Shipping Policy" },
  { label: "Return Policy", tab: "Return Policy" },
  { label: "Refund Policy", tab: "Refund Policy" },
  { label: "Privacy Policy", tab: "Privacy Policy" },
];

export const Footer = () => {
  const socialIcons: { name: string; src: any }[] = [
    { name: "facebook", src: require("../../assets/icons/fb.png") },
    { name: "instagram", src: require("../../assets/icons/insta.png") },
    { name: "twitter", src: require("../../assets/icons/twitter.png") },
  ];

  const navigate = useNavigate();

  const handleLinkClick = (tab: string) => {
    if (tab) {
      navigate(`/documents?tab=${encodeURIComponent(tab)}`);
    }
  };

  return (
    <View style={styles.footerContainer}>
      <ScrollView horizontal={false} contentContainerStyle={{ paddingHorizontal: 16 }}>
        <View style={styles.footerRow}>
          {/* Logo */}
          <Image
            source={require("../../assets/images/full_logo.png")}
            style={styles.footerLogo}
            resizeMode="contain"
          />

          {/* Information */}
          <View style={styles.footerColumn}>
            <Text style={styles.footerTitle}>Information</Text>
            {footerLinks.map((link, index) => (
              <TouchableOpacity key={index} onPress={() => handleLinkClick(link.tab)}>
                <Text style={styles.footerLink}>{link.label}</Text>
              </TouchableOpacity>
            ))}
          </View>

              {/* Reach Us */}
            <View style={styles.reachUsSection}>
              <Text style={styles.footerTitle}>Reach Us</Text>
              <Text style={styles.contactText}>Sudheer.manthri@gmail.com</Text>
              <Text style={styles.contactText}>9100019419</Text>
            </View>

          {/* Social + Reach Us */}
          <View style={styles.footerColumn}>
            <View style={styles.socialSection}>
              <Text style={styles.footerTitle}>WE ARE SOCIAL</Text>
              <View style={styles.socialRow}>
                {socialIcons.map((icon, index) => (
                  <TouchableOpacity key={index} style={styles.socialIconContainer}>
                    <Image
                      source={icon.src}
                      style={{ width: 24, height: 24 }}
                      resizeMode="contain"
                    />
                  </TouchableOpacity>
                ))}
              </View>
            </View>

        
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  footerContainer: {
    fontFamily: "Arimo, sans-serif",
    backgroundColor: "#F7E6EE",
    paddingVertical: 24,
  },
  footerRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: 24,
  },
  footerLogo: {
    width: 250,
    height: 80,
    marginRight: 120,
  },
  footerColumn: {
    flex: 1,
    marginHorizontal: 8,
    minWidth: 140,
  },
  footerTitle: {
    fontSize: 17,
    fontWeight: "600",
    marginBottom: 12,
    color: "#000",
  },
  footerLink: {
    fontSize: 16,
    color: "#333",
    marginBottom: 12,
  },
  socialSection: {
    marginTop: 8,
    alignItems: "center",
  },
  socialRow: {
    flexDirection: "row",
    justifyContent: "center",
    marginTop: 12,
  },
  socialIconContainer: {
    width: 50,
    height: 50,
    borderRadius: 12,
    backgroundColor: "#fff",
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.2,
    shadowRadius: 2,
    elevation: 2,
  },
  reachUsSection: {
    alignItems: "flex-start",
  },
  contactText: {
    fontSize: 15,
    color: "#333",
    marginBottom: 6,
  },
});
